import { ButtonMui } from 'src/components/ButtonMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const FilterContainer = styled.div`
    display: flex;
    margin-top: 1rem;
    gap: 1.4rem;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
`

export const Container = styled.div`
    display: flex;
    margin-top: 0.8rem;
    width: 100%;
`

export const ContainerTotal = styled.div`
    display: flex;
    flex-direction: column;
    width: 30%;
`

export const CustomButton = styled(ButtonMui)`
    width: 12rem !important;    
    height: 3rem !important;
    margin: 0 !important;
`

export const CustomTextField = styled(TextFieldMui)`
    margin: 0 !important;
    width: 12rem !important;

    & input {
        height: 1rem !important;
    }
`

export const CustomText = styled.p`
    display: flex;
    justify-content: flex-end;
    font-size: 1rem;
`

export const CustomTextWrapper = styled.div`
  display: flex;
  width: 160%;
  justify-content: flex-end;
  gap: 1.4rem;
  margin-bottom: 0;
  height: 3rem !important;
`
